import {QueryClient} from '@tanstack/query-core';
import {createSyncStoragePersister} from '@tanstack/query-sync-storage-persister';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: (error: any) => {
        if ([401, 403].includes(error?.status)) {
          queryClient.invalidateQueries(['me']);
        }
      },
    },
  },
});

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
